import endPoints from 'utils/endPoints';
import { PostMutate, PutMutate } from 'utils/mutationAndQuery/customMutation';
import { FetchAllData } from 'utils/mutationAndQuery/customUseQuery';

export const onCreateShop = () => {
  const { message, isPending, mutate, isSuccess, isError, clearData } =
    PostMutate(endPoints.createShop);

  return {
    loading: isPending,
    submitData: mutate,
    message: message,
    isSuccess,
    isError,
    clearData,
  };
};

export const onLoginUser = () => {
  const {
    data,
    message,
    isPending,
    mutate,
    isSuccess,
    isError,
    clearData,
    accessToken,
    refreshToken,
  } = PostMutate(endPoints.Login);
  return {
    loading: isPending,
    submitData: mutate,
    message: message,
    isSuccess,
    isError,
    clearData,
    data,
    accessToken,
    refreshToken,
  };
};

export const fetchUserData = () => {
  const { data, isLoading, isSuccess } = FetchAllData({
    url: endPoints.userData,
  });

  return {
    isLoading,
    userData: data?.data ?? [],
    message: data?.message,
    isSuccess,
  };
};

export const fetchAllUsers = () => {
  const { data, isLoading, isSuccess } = FetchAllData({
    url: endPoints.fetchUsers,
  });

  return {
    isLoadingUsers: isLoading,
    getUsers: data?.data ?? [],
    message: data?.message,
    isSuccess,
  };
};

export const userLogout = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = PostMutate(endPoints.logout);
  return {
    logoutUserData: data,
    loadLogoutUser: isPending,
    isLogoutUserError: isError,
    isLogoutUserSuccess: isSuccess,
    logoutUserMessage: message,
    logoutUserError: error,
    mutate,
    clearData,
  };
};

export const onRegisterUser = () => {
  const { message, isPending, mutate, isSuccess, isError, clearData } =
    PostMutate(endPoints.registerUser, endPoints.fetchUsers);

  return {
    loadRegister: isPending,
    requestRegisterUser: mutate,
    registerUserMessage: message,
    successResponse: isSuccess,
    errorResponse: isError,
    clearRegisterUser: clearData,
  };
};

export const fetchUserRoles = () => {
  const { data, isLoading, isSuccess } = FetchAllData({
    url: endPoints.userRoles,
  });

  return {
    isLoadingRoles: isLoading,
    userRoles: data?.data ?? [],
    message: data?.message,
    isSuccess,
  };
};

export const fetchUserPermission = () => {
  const { data, isLoading, isSuccess } = FetchAllData({
    url: endPoints.managePermission,
  });

  return {
    isLoadingPermission: isLoading,
    userPermission: data?.data ?? [],
    message: data?.message,
    isSuccess,
  };
};

export const requestUpdatePermission = () => {
  const { message, isPending, mutate, isSuccess, isError, clearData } =
    PostMutate(endPoints.rolePermissions, endPoints.managePermission);

  return {
    loadUpdatePermission: isPending,
    updatePermission: mutate,
    updatePermissionMessage: message,
    successResponse: isSuccess,
    errorUpdatePermissionResponse: isError,
    clearUpdatePermission: clearData,
  };
};

export const requestUpdateUserProfile = () => {
  const { message, isPending, mutate, isSuccess, isError, clearData } =
    PutMutate(endPoints.updateUserProfile, endPoints.fetchUsers);

  return {
    loadUpdateUserProfile: isPending,
    updateUserProfile: mutate,
    updateUserProfileMessage: message,
    successResponse: isSuccess,
    errorUpdateUserProfileResponse: isError,
    clearUpdateUserProfile: clearData,
  };
};

export const requestResetUserPassword = () => {
  const {
    data,
    message,
    isPending,
    mutate,
    isSuccess,
    isError,
    clearData,
    error,
  } = PutMutate(endPoints.resetPassword);

  return {
    loadResetPassword: isPending,
    resetPassword: mutate,
    resetPasswordResponse: message,
    successResetPassword: isSuccess,
    errorResetPassword: isError,
    clearResetPasswordResponse: clearData,
    responseData: data?.data,
    responseError: error,
  };
};

export const requestChangeLanguage = () => {
  const { message, isPending, mutate, isSuccess, isError, clearData } =
    PutMutate(endPoints.changeLanguage);

  return {
    loadChangeLang: isPending,
    changeLang: mutate,
    changeLangResponse: message,
    successChangeLang: isSuccess,
    errorChangeLang: isError,
    clearChangeLangResponse: clearData,
  };
};
